import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import BreadcrumbsBg from "../Assets/img/breadcrumbs-bg.png";
import CallAction from "../Components/CallAction";

const AcademicFees = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section
        className="eschool-breadcrumbs"
        style={{ backgroundImage: `url(${BreadcrumbsBg})` }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">
              <div className="eschool-breadcrumbs-content">
                <h3 className="eschool-bread-cont-title">Academic Fees</h3>
                <ul className="eschool-bread-menu">
                  <li>
                    <Link to="/">Home</Link>
                    <i class="fi fi-br-angle-right"></i>
                  </li>
                  <li>
                    <Link to="/academicfees">Academic Curriculum</Link>
                    <i class="fi fi-br-angle-right"></i>
                  </li>
                  <li className="active">
                    <Link to="/academicfees">Academic Fees</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="eschool-academic-fees">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="academic-fees-inner">
                <div className="academic-fees-top">
                  <span class="class-fees-title">Fees details</span>
                  <span className="class-one">Class one</span>
                  <span className="class-two">Class two</span>
                  <span className="class-three">Class three</span>
                  <span className="class-four">Class four</span>
                  <span className="class-five">Class five</span>
                  <span className="class-six">Class six</span>
                  <span className="class-seven">Class seven</span>
                  <span className="class-eight">Class eight</span>
                  <span className="class-nine">Class nine</span>
                  <span className="class-ten">Class ten</span>
                </div>
                <div className="academic-fees-details">
                  <div className="academic-fees-details-single">
                    <span class="class-fees-details-title">
                      Academic fees <br /> (one time, non-refundable)
                    </span>
                    <span className="class-one-tk">2,000 TK</span>
                    <span className="class-two-tk">3,000 TK</span>
                    <span className="class-three-tk">4,000 TK</span>
                    <span className="class-four-tk">5,000 TK</span>
                    <span className="class-five-tk">6,000 TK</span>
                    <span className="class-six-tk">7,000 TK</span>
                    <span className="class-seven-tk">8,000 TK</span>
                    <span className="class-eight-tk">9,000 TK</span>
                    <span className="class-nine-tk">10,000 TK</span>
                    <span className="class-ten-tk">11,000 TK</span>
                  </div>
                  <div className="academic-fees-details-single">
                    <span class="class-fees-details-title">
                      Security deposit <br /> (one time, non-refundable)
                    </span>
                    <span className="class-one-tk">2,000 TK</span>
                    <span className="class-two-tk">3,000 TK</span>
                    <span className="class-three-tk">4,000 TK</span>
                    <span className="class-four-tk">5,000 TK</span>
                    <span className="class-five-tk">6,000 TK</span>
                    <span className="class-six-tk">7,000 TK</span>
                    <span className="class-seven-tk">8,000 TK</span>
                    <span className="class-eight-tk">9,000 TK</span>
                    <span className="class-nine-tk">10,000 TK</span>
                    <span className="class-ten-tk">11,000 TK</span>
                  </div>
                  <div className="academic-fees-details-single">
                    <span class="class-fees-details-title">
                      Tution fees <br /> (Annual)
                    </span>
                    <span className="class-one-tk">2,000 TK</span>
                    <span className="class-two-tk">3,000 TK</span>
                    <span className="class-three-tk">4,000 TK</span>
                    <span className="class-four-tk">5,000 TK</span>
                    <span className="class-five-tk">6,000 TK</span>
                    <span className="class-six-tk">7,000 TK</span>
                    <span className="class-seven-tk">8,000 TK</span>
                    <span className="class-eight-tk">9,000 TK</span>
                    <span className="class-nine-tk">10,000 TK</span>
                    <span className="class-ten-tk">11,000 TK</span>
                  </div>
                  <div className="academic-fees-details-single">
                    <span class="class-fees-details-title">
                      Tution fees <br /> (Monthly)
                    </span>
                    <span className="class-one-tk">2,000 TK</span>
                    <span className="class-two-tk">3,000 TK</span>
                    <span className="class-three-tk">4,000 TK</span>
                    <span className="class-four-tk">5,000 TK</span>
                    <span className="class-five-tk">6,000 TK</span>
                    <span className="class-six-tk">7,000 TK</span>
                    <span className="class-seven-tk">8,000 TK</span>
                    <span className="class-eight-tk">9,000 TK</span>
                    <span className="class-nine-tk">10,000 TK</span>
                    <span className="class-ten-tk">11,000 TK</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CallAction />
    </>
  );
};

export default AcademicFees;
